import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * @param {string} adminToken 필수
 */
const GetRenderServerStatus = async (adminToken) => {
    try {
        const url = `${GetBaseUrl()}/apis/admin/system/pause-rendering-status`
        const config = {
            headers: { Authorization: `Bearer ${adminToken}` }
        }
        const response = await axios.get(url, config)

        const result = (response.status === 200)
        const resultData = response.data.data
        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    GetRenderServerStatus
}